import { render, staticRenderFns } from "./ChatWidgetPreview.vue?vue&type=template&id=a506d040&scoped=true"
import script from "./ChatWidgetPreview.vue?vue&type=script&lang=js"
export * from "./ChatWidgetPreview.vue?vue&type=script&lang=js"
import style0 from "./ChatWidgetPreview.vue?vue&type=style&index=0&id=a506d040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a506d040",
  null
  
)

export default component.exports